import PaymentAbstractDialog from "./PaymentAbstractDialog";

export default class BalancePaymentDialog extends PaymentAbstractDialog {

    title = "invoice.balancePayment";
    dialogSaveLabel = "invoice.confirmReplenishment";

    get balanceLabel() {
        return "invoice.replenishmentMethod";
    }

    getItemMaxSum(bSum, sum) {
        return sum;
    }

    joinSaveInfo(info) {
        return {
            ...info,
            direction: "DIRECTION_ADD",
        };
    }
}
